<template>
    <v-layout>
      <v-flex :class="{'xs11': deleteable && !addable, 'xs10': addable && !deleteable, 'xs10': deleteable && addable}">
        <v-text-field
          :append-icon="appendIcon"
          :auto-grow="autoGrow"
          :autofocus="autofocus"
          :filled="filled"
          :clearable="clearable"
          :color="color"
          :counter="counter"
          :class="classname"
          :dark="dark"
          :disabled="disabled"
          :dont-fill-mask-blanks="dontFillMaskBlanks"
          :error="error"
          :error-messages="errorMessages"
          :full-width="fullWidth"
          :hide-details="hideDetails"
          :hint="hint"
          :id="id"
          :index="index"
          :label="label"
          :light="light"
          :loading="loading"
          :mask="mask"
          :multi-line="multiLine"
          :name="id"
          :persistent-hint="persistentHint"
          :placeholder="placeholder"
          :prefix="prefix"
          :prepend-icon="prependIcon"
          :readonly="readonly"
          :required="required"
          :return-masked-value="returnMaskedValue"
          :rows="rows"
          :rules="rules"
          ref="autocomplete"
          :single-line="singleLine"
          :solo="solo"
          :suffix="suffix"
          :tabindex="tabindex"
          :textarea="textarea"
          :toggle-keys="toggleKeys"
          type="text"
          :validate-on-blur="validateOnBlur"
          v-model="autocompleteText"
          @focus="onFocus()"
          @blur="onBlur()"
          @change="onChange"
          @keypress="onKeyPress"
        ></v-text-field>
      </v-flex>
      <v-flex xs1 v-if="addable">
        <v-btn
          fab
          x-small
          color="primary"
          elevation="0"
        @click="onAdd(index)"
        style="position:relative; bottom:-20px; right:-10px; height: 20px;
    width: 20px;"><v-icon>add</v-icon></v-btn>
      </v-flex>
      <v-flex xs1 v-if="deleteable">
        <v-btn icon
        @click="onRemove(index)"
        style="position:relative; bottom:-15px"><v-icon>delete</v-icon></v-btn>
      </v-flex>
    </v-layout>

</template>

<script>
var google = window.google;
export default {
  name: 'gInput',

  props: {
    appendIcon: {
      type: String,
      default: null
    },

    autoGrow: {
      type: Boolean,
      default: false
    },

    autofocus: {
      type: Boolean,
      default: false
    },

    filled: {
      type: Boolean,
      default: false
    },

    clearable: {
      type: Boolean,
      default: false
    },
    deleteable: {
      type: Boolean,
      default: false
    },
    addable: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'primary'
    },

    counter: {
      type: [Boolean, Number],
      default: false
    },

    country: {
      type: [String, Array],
      default: null
    },

    classname: {
      type: String,
      default: ''
    },

    dark: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    dontFillMaskBlanks: {
      type: Boolean,
      default: false
    },

    enableGeolocation: {
      type: Boolean,
      default: false
    },

    error: {
      type: Boolean,
      default: false
    },

    errorMessages: {
      type: Array,
      default: () => {
        return [];
      }
    },

    fullWidth: {
      type: Boolean,
      default: false
    },

    hideDetails: {
      type: Boolean,
      default: true
    },

    hint: {
      type: String,
      default: ''
    },

    id: {
      type: String,
      required: true
    },

    index: {
      type: Number,
      default: 0
    },

    label: {
      type: String,
      default: ''
    },

    light: {
      type: Boolean,
      default: true
    },

    loading: {
      type: [Boolean, String],
      default: false
    },

    mask: {
      type: String,
      default: null
    },

    multiLine: {
      type: Boolean,
      default: false
    },

    persistentHint: {
      type: Boolean,
      default: false
    },

    placeholder: {
      type: String,
      default: ''
    },

    prefix: {
      type: String,
      default: ''
    },

    prependIcon: {
      type: String,
      default: null
    },

    readonly: {
      type: Boolean,
      default: false
    },

    required: {
      type: Boolean,
      default: true
    },

    returnMaskedValue: {
      type: Boolean,
      default: false
    },

    rows: {
      type: Number,
      default: 5
    },

    rules: {
      type: Array,
      default: () => {
        return [];
      }
    },

    singleLine: {
      type: Boolean,
      default: false
    },

    solo: {
      type: Boolean,
      default: false
    },

    suffix: {
      type: String,
      default: ''
    },

    tabindex: {
      type: Number,
      default: 0
    },

    textarea: {
      type: Boolean,
      default: false
    },

    toggleKeys: {
      type: Array,
      default: () => {
        return [13, 32];
      }
    },

    validateOnBlur: {
      type: Boolean,
      default: false
    },

    types: {
      type: String,
      default: 'address'
    }
  },

  data: function () {
    return {
      /**
       * The Autocomplete object.
       *
       * @type {Autocomplete}
       * @link https://developers.google.com/maps/documentation/javascript/reference#Autocomplete
       */
      autocomplete: null,

      /**
       * Autocomplete input text
       * @type {String}
       */
      autocompleteText: ''
    };
  },

  watch: {
    autocompleteText: function (newVal, oldVal) {
      this.$emit('inputChange', { newVal, oldVal });
    }
  },

  mounted: function () {
    const options = { placeIdOnly: true };

    if (this.types) {
      options.types = [this.types];
    }

    if (this.country) {
      options.componentRestrictions = {
        country: this.country
      };
    }

    // Override the default placeholder
    // text set by Google with the
    // placeholder prop value.
    document
      .getElementById(this.id)
      .setAttribute('placeholder', this.placeholder);

    this.init();
  },

  methods: {
    /**
     * When the input gets focus
     */
    onFocus () {
      this.geolocate();
      this.$emit('focus');
    },

    /**
     * When the input loses focus
     */
    onBlur () {
      this.$emit('blur');
    },

    /**
     * When the input got changed
     */
    onChange () {
      this.$emit('change', this.autocompleteText);
    },
    onRemove (i) {
      this.$emit('remove', i);
    },
    onAdd (i) {
      this.$emit('add', i);
    },
    /**
     * When a key gets pressed
     * @param  {Event} event A keypress event
     */
    onKeyPress (event) {
      this.$emit('keypress', event);
    },

    /**
     * Clear the input
     */
    clear () {
      this.autocompleteText = '';
    },

    /**
     * Focus the input
     */
    focus () {
      this.$refs.autocomplete.focus();
    },

    /**
     * Blur the input
     */
    blur () {
      this.$refs.autocomplete.blur();
    },

    /**
     * Update the value of the input
     * @param  {String} value
     */
    update (value) {
      this.autocompleteText = value;
    },
    prefill (value) {
      // update autocompleteText then emit change event
      this.autocompleteText = document.getElementById(this.id).value = value;
      this.onChange();
    },
    // Bias the autocomplete object to the user's geographical location,
    // as supplied by the browser's 'navigator.geolocation' object.
    geolocate () {
      if (this.enableGeolocation) {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(position => {
            var geolocation = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };
            var circle = new google.maps.Circle({
              center: geolocation,
              radius: position.coords.accuracy
            });
            this.autocomplete.setBounds(circle.getBounds());
          });
        }
      }
    },
    init () {
      this.autocomplete = new google.maps.places.Autocomplete(
        document.getElementById(this.id),
        { placeIdOnly: false }
        // options
      );
      this.autocomplete.addListener('place_changed', () => {
        var place = this.autocomplete.getPlace();

        if (!place.geometry) {
          // User entered the name of a Place that was not suggested and
          // pressed the Enter key, or the Place Details request failed.
          this.$emit('no-results-found', place);
          return;
        }

        var addressComponents = {
          street_number: 'short_name',
          route: 'long_name',
          locality: 'long_name',
          administrative_area_level_1: 'short_name',
          country: 'long_name',
          postal_code: 'short_name'
        };

        var returnData = {};

        if (place.address_components !== undefined) {
          // Get each component of the address from the place details
          for (var i = 0; i < place.address_components.length; i++) {
            var addressType = place.address_components[i].types[0];

            if (addressComponents[addressType]) {
              var val =
                place.address_components[i][addressComponents[addressType]];
              returnData[addressType] = val;
            }
          }

          returnData['latitude'] = place.geometry.location.lat();
          returnData['longitude'] = place.geometry.location.lng();

          // return returnData object and PlaceResult object
          this.$emit('placechanged', returnData, place, this.id);

          // update autocompleteText then emit change event

          this.autocompleteText = document.getElementById(this.id).value = place.formatted_address;
          this.onChange();
        }
      });
    }
  }
};
</script>
